// todo: this is no longer an admin controller
export enum AdminStereoVideosRoutes {
  GetOne = 'get-one',
  GetMany = 'get-many',
}
